import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { DoItYourselfAPIModelImpl, DoItYourselfAPIModel } from './doityourselfapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { DoItYourselfViewImpl } from './doityourselfview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { DoItYourselfCSSStyleImpl } from './doityouselfcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { FileUploadStatus } from '../../../toolkit/fileupload/fileuploadcomponent';
import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { UploadKaroakeDto } from 'src/com/sixdee/crbtportal/core/dto/uploadkaroake/uploadkaroakedto';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export interface DoItYourselfComponentProps extends CRBTUIComponentProps
{

}

export interface DoItYourselfComponentHandler extends UIComponentHandler
{
    onSubmitClicked(): void;
    onReuploadClicked(): void;
    onFileSelected(toneName: string): void;
}


export interface DoItYourselfComponentState extends UIComponentState
{
    toneName: string;
    fileUploadStatus: FileUploadStatus;
    uploadProgressPercentage: number;
}


export class DoItYourselfComponent extends CRBTUIComponent<DoItYourselfComponentProps, DoItYourselfComponentState> implements
DoItYourselfComponentHandler
{
    constructor(props: DoItYourselfComponentProps)
    {
        super(props);

        this.state = {fileUploadStatus: FileUploadStatus.FILE_UPLOAD, toneName: "", uploadProgressPercentage: 0};
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DoItYourselfViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DoItYourselfCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new DoItYourselfAPIModelImpl(applicationContext, apiModelHandler);
    }

    onSubmitClicked(): void 
    {
        if(this.getView().validate() && (this.getView() as DoItYourselfViewImpl).validateFile())
        {
            if((this.getView() as DoItYourselfViewImpl).isRememberMe())
            {
                this.props.context.getUserContext().setIsTermsAndConditionsRemember(
                                     (this.getView() as DoItYourselfViewImpl).isRememberMe());
                this.props.context.setUserContext(this.props.context.getUserContext());
     
                this.setState({fileUploadStatus: FileUploadStatus.FILE_UPLOADING});
                 (this.getAPIModel() as DoItYourselfAPIModel).getDoItYourself((this.getView().getData() as UploadKaroakeDto));
            }
            else
            {
                (this.getView() as DoItYourselfViewImpl).showPopup(this.getContext().getResources().getString(Strings.please_accept_terms_and_condition), AlertType.WARN, "OK");
            }
        }
    }
    
    onFileSelected(toneName: string): void 
    {
        if((this.getView() as DoItYourselfViewImpl).validateFile())
        {
            this.setState({fileUploadStatus: FileUploadStatus.FILE_PREVIEW, toneName: toneName});
        }
        else
        {
            (this.getView() as DoItYourselfViewImpl).showPopup(this.getContext().getResources().getString(Strings.Invalid_file_length), AlertType.WARN, this.getContext().getResources().getString(Strings.ok));
        }
    }

    setUploadProgress(percentage: number)
    {
        this.state.fileUploadStatus === FileUploadStatus.FILE_UPLOADING &&
         this.setState({uploadProgressPercentage: percentage});
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        // (this.getView() as DoItYourselfViewImpl).showPopup("Successfully uploaded File", AlertType.SUCCESS);
        this.setState({fileUploadStatus: FileUploadStatus.FILE_UPLOADED, toneName: "",  uploadProgressPercentage: 0});

        setTimeout(() =>{
            this.setState({fileUploadStatus: FileUploadStatus.FILE_UPLOAD});
        }, 4000);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        // (this.getView() as DoItYourselfViewImpl).clearData();
        (this.getView() as DoItYourselfViewImpl).showPopup(this.getContext().getResources().getString(Strings.Failed_to_upload_file), AlertType.ERROR, this.getContext().getResources().getString(Strings.ok));
        this.setState({fileUploadStatus: FileUploadStatus.FILE_UPLOAD, toneName: "",  uploadProgressPercentage: 0});
    }

    onReuploadClicked(): void 
    {
        this.setState({fileUploadStatus: FileUploadStatus.FILE_UPLOAD, toneName: "", uploadProgressPercentage: 0});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/doityourself/doityourselfcomponent.tsx